<template>
    <div class="page">
        <div class="top text-center">开福消防签到系统欢迎您！</div>
        <div
            class="d-flex justify-content-center align-item-center success-top"
        >
            <button class="exit-btn" @click="exit()">退出</button>
            <img src="../assets/success_icon.png" alt="" />
            <span>签到成功</span>
        </div>
        <p class="sign-name text-center">您是第{{ number }}位签到者</p>
        <p class="sign-desc text-center">签到时间：{{ time }}</p>
        <p class="sign-desc text-center">签到地点：长沙市开福区潮宗街消防站</p>
        <p class="sign-desc text-center">单位名称：长沙市开福区潮宗街政府专职消防救援站</p>

        <div class="d-flex justify-content-center align-item-center results-content">
            <img :src="photo" alt="" class="user-img" v-if="photo">
            <div class="sign-img-content">
                <img :src="signImg" alt="" v-if="signImg" />
            </div>
            <div class="qrcode-content">
                <div class="qrcode-img">
                    <div id="qrcode" ref="qrcode"></div>
                </div>
                <div class="text-center text">手机扫描二维码<br />下载签到海报</div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
    name: "home",
    data() {
        return {
            baseUrl: "http://kfxf.vip.api.hnlinghou.com/",
            ossUrl: "https://oss.kaifahou.com/",
            time: "",
            signImg: "",
            qrcodeLink: "",
            num:'',
            photo:'',
            number:''
        };
    },
    created() {
        var img = this.ossUrl + this.$route.query.url;
        this.signImg = img;
        this.number = this.$route.query.num;
        this.getTime();
    },
    mounted() {
        var img = this.ossUrl + this.$route.query.url;
        var num = this.$route.query.num;
        if(this.$route.query.photo){
            this.photo = this.ossUrl + this.$route.query.photo;
        }else{
            this.photo = ''
        }
        this.$http
            .get(this.baseUrl + "index/index/signin", {
                params: {
                    img,
                    num,
                    photo:this.photo
                },
            })
            .then((res) => {
                this.qrcodeLink = res.data.url;
                this.qrcodeScan();
            })
            .catch((err) => {});
        
    },
    methods: {
        getTime(){
            var date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            let second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

            this.time = year + '年' + month + '月' + day + '日' +'  ' + hour + ':' + minute + ':' + second 
        },
        exit() {
            this.$router.push({ path: "/" });
        },
        qrcodeScan() {
            //生成二维码
            let qrcode = new QRCode("qrcode", {
                width: 160, // 二维码宽度
                height: 160, // 二维码高度
                text: this.qrcodeLink,
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 100vh;
    background: url("../assets/bg.png") no-repeat;
    background-size: cover;
}
.top {
    height: 120px;
    line-height: 120px;
    color: #fff;
    background: rgba(0, 0, 0, 0.29);
    font-size: 42px;
}
.sign-img-content {
    width: 600px;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 10px rgba(77, 16, 15, 0.38);
    border-radius: 10px;
    overflow: hidden;
    margin-right: 30px;
}
.sign-name {
  font-size: 60px;
  color: #ffc776;
  margin: 30px 0 60px;
}
.sign-img-content img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.success-top {
    font-size: 60px;
    color: #ffc776;
    margin: 50px 0 40px;
    position: relative;
}
.exit-btn {
    position: absolute;
    right: 80px;
    top: -20px;
    width: 250px;
    height: 90px;
    line-height: 90px;
    border: 0;
    outline: 0;
    color: #3a2200;
    font-size: 42px;
    background: #e9a23c;
    border-radius: 10px;
}
.success-top img {
    margin-right: 10px;
}
.sign-desc {
    font-size: 20px;
    color: #fff;
    margin-bottom: 20px;
}
.results-content{
    margin-top: 60px;
}
.qrcode-content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.qrcode-content .text {
    color: #fff;
    font-size: 30px;
    margin-top: 20px;
}
.qrcode-img {
    padding: 10px;
    width: 160px;
    height: 160px;
    background: #fff;
}
.user-img{
    width: 225px;
    height: 300px;
    box-shadow: 0px 0px 23px 11px rgba(77, 16, 15, 0.38);
    border-radius: 11px;
    margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/success.vue